enum PensionProfileCategory {
  MINPENSJONSPROFILAKTIV = 'MINPENSJONSPROFILAKTIV',
  MINPENSJONSPROFILINDEKS = 'MINPENSJONSPROFILINDEKS',
  MINPENSJONSPROFILINDEKSUTENNEDVEK = 'MINPENSJONSPROFILINDEKSUTENNEDVEK',
  MINPENSJONSPROFILAKTIVUTENNEDVEK = 'MINPENSJONSPROFILAKTIVUTENNEDVEK',
  MALPROFIL = 'MALPROFIL',
  MALPROFILINDEKS = 'MALPROFILINDEKS',
  PORTEFOLJE = 'PORTEFOLJE',
  PORTEFOLJEUTENNEDVEK = 'PORTEFOLJEUTENNEDVEK',
  APENMENY = 'APENMENY',
  FLEXPROFIL = 'FLEXPROFIL',
  FLEXFOND = 'FLEXFOND',
  UNDEFINED = 'UNDEFINED',
}

export default PensionProfileCategory;
